const differenceTwoTime = (wert1: any, wert2: any) => {
    const date1: any = new Date(wert1)
    const date2: any = new Date(wert2)
    const diffDays = (date1 - date2) / (1000 * 60) / 60

    return parseFloat(String(diffDays))
}

export default differenceTwoTime
